import { tools } from 'newcar-ui/output/es/utils';

// const testBaseIp = '//10.167.100.13:8001'
const testBaseIp = '//172.29.75.166:8001';
const onlineBaseIp = '//m.58che.com';

let domainAjaxUrl = '';
const domainBaseServeUrl = '/activity/ajax_autoshowbj2024_index/'
const curEnv = tools.getDomainName();
const curHostName = window.location.hostname
if (curEnv === '-tests' || curHostName == 'localhost' || curHostName === '172.29.75.166') {
  domainAjaxUrl = testBaseIp + domainBaseServeUrl;
} else if (curEnv === '-box' || curHostName == '10.167.100.13') {
  domainAjaxUrl = onlineBaseIp + domainBaseServeUrl;
} else {
  domainAjaxUrl = onlineBaseIp + domainBaseServeUrl;
}

//  mock
// domainAjaxUrl = '//escapim.58corp.com/app/mock/312'
domainAjaxUrl = '//huodong.58che.com'
/**
 * 
 * @param {*} params 
 * @returns 
 */
export const getDefaultInfo = (params) => {
  return tools.request(`${domainAjaxUrl}/activity/ajax_autoshowbj2024_index/index/`, params, 'jsonp')
}


/**
 * 图文模块数据
 * @param {*} params 
 * @returns 
 */
export const getMoudleData = (params) => {
  return tools.request(`${domainAjaxUrl}/activity/ajax_autoshowbj2024_index/module/`, params, 'jsonp')
}

/**
 * 直播列表数据
 * @param {*} params 
 * @returns 
 */
export const getLiveModuleData = (params) => {
  return tools.request(`${domainAjaxUrl}/activity/ajax_autoshowbj2024_live/index/`, params, 'jsonp')
}

/**
 * 直播间数据
 * @param {string} liveid 直播间信息
 * @returns 
 */
export const getLiveRoomData = (liveid) => {
  return tools.request(`${domainAjaxUrl}/activity/ajax_autoshowbj2024_live/info`, liveid, 'jsonp')
}